export const TABLET_MIN_WIDTH_PX = 768;
export const PC_MIN_WIDTH_PX = 1020;

export const mediaQureyWidthPairs = {
  pc: { min: `${PC_MIN_WIDTH_PX}px` },
  tablet: { min: `${TABLET_MIN_WIDTH_PX}px`, max: `${PC_MIN_WIDTH_PX - 1}px` },
  sp: { max: `${TABLET_MIN_WIDTH_PX - 1}px` },
};

export type MediaQureyWidthPairs = typeof mediaQureyWidthPairs;

export const mediaQurey = <
  T extends keyof MediaQureyWidthPairs,
  S extends keyof MediaQureyWidthPairs
>(
  minMax: keyof MediaQureyWidthPairs[T],
  deviceType: T,
  minMax2?: keyof MediaQureyWidthPairs[S],
  deviceType2?: S,
) =>
  `@media (${String(minMax)}-width: ${mediaQureyWidthPairs[deviceType][minMax]})${(minMax2 && deviceType2)
    ? ` and (${String(minMax2)}-width: ${mediaQureyWidthPairs[deviceType2][minMax2]})`
    : ''}`;
